import { useTranslation } from "react-i18next";
import { ContentPanel, PageBanner, UnorderedList } from "../components";
import { MedicalStaffingSolutionsBanner } from "../images";

export const MedicalStaffingSolutions = () => {
    const { t } = useTranslation();
    const keyFeatures = t('medicalStaffingSolutions.keyFeatures', { returnObjects: true }) as string[]

    return (
        <div>
            <PageBanner image={MedicalStaffingSolutionsBanner} title={t('medicalStaffingSolutions.bannerTitle')} />

            <ContentPanel headerText={t('medicalStaffingSolutions.header')}>
                <h4 className="text-xl mb-5">{t('generic.keyFeatures')}</h4>

                <UnorderedList items={keyFeatures} />

                <h4 className="text-xl my-5">{t('generic.industriesServed')}</h4>
                <span className="text-white leading-relaxed">{t('medicalStaffingSolutions.industriesServed')}</span>
            </ContentPanel>
        </div>
    );
};